<template>
    <div class="md-layout-item">
        <div class="custom-toolbar">
            <div class="custom-toolbar-start">
                <div class="filter-steps--container">
                    <team-region-member-filter-options
                        v-if="
                            canViewTeamRegion &&
                                showFilter([
                                    activeTabsFilters.ProcessChargesStops,
                                    activeTabsFilters.ProcessChargesShipments,
                                    activeTabsFilters.ProcessChargesTrips,
                                    activeTabsFilters.ProcessChargesOrders,
                                    activeTabsFilters.DriverAdjustments
                                ])
                        "
                        :team-region-id="teamRegionId"
                        @changed="handleTeamRegionMemberChanged"
                        :strict-team-region-filter="true"
                        :use-elevated-filter-view="true"
                        :clearable="false"
                        :selected-team-member="filters.selectedTeamMember"
                    />
                    <md-field
                        v-if="
                            showFilter([
                                activeTabsFilters.ProcessChargesStops,
                                activeTabsFilters.ProcessChargesShipments,
                                activeTabsFilters.ProcessChargesTrips,
                                activeTabsFilters.ProcessChargesOrders
                            ])
                        "
                    >
                        <customer-filter-options
                            class="filter-steps--choices filter-status"
                            :filter-customer-id="filters.customerId"
                            @onCustomerSelected="handleCustomerChanged"
                        />
                    </md-field>

                    <md-field
                        v-if="
                            showFilter([activeTabsFilters.ProcessChargesStops, activeTabsFilters.ProcessChargesOrders])
                        "
                    >
                        <process-charge-status-filter
                            class="filter-steps--choices filter-status"
                            :filter-status-filter="filters.status"
                            :status-list="statusFilterOptions"
                            @onStatusSelected="handleStatusFilterChanged"
                        />
                    </md-field>

                    <md-field
                        v-if="
                            showFilter([
                                activeTabsFilters.ProcessChargesStops,
                                activeTabsFilters.ProcessChargesShipments,
                                activeTabsFilters.ProcessChargesTrips,
                                activeTabsFilters.ProcessChargesOrders,
                                activeTabsFilters.DriverAdjustments,
                                activeTabsFilters.CustomerAdjustments
                            ])
                        "
                    >
                        <md-datepicker
                            class="filter-steps--choices filter-step-date start-date"
                            v-model="filters.fromDate"
                            md-immediately
                            :md-debounce="100"
                        ></md-datepicker>
                    </md-field>

                    <md-field
                        v-if="
                            showFilter([
                                activeTabsFilters.ProcessChargesStops,
                                activeTabsFilters.ProcessChargesShipments,
                                activeTabsFilters.ProcessChargesTrips,
                                activeTabsFilters.ProcessChargesOrders,
                                activeTabsFilters.DriverAdjustments,
                                activeTabsFilters.CustomerAdjustments
                            ])
                        "
                    >
                        <md-datepicker
                            class="filter-steps--choices filter-step-date end-date"
                            v-model="filters.toDate"
                            md-immediately
                            :md-debounce="100"
                        ></md-datepicker>
                    </md-field>

                    <md-field
                        v-if="
                            showFilter([
                                activeTabsFilters.ProcessChargesStops,
                                activeTabsFilters.ProcessChargesShipments,
                                activeTabsFilters.ProcessChargesTrips,
                                activeTabsFilters.ProcessChargesOrders
                            ])
                        "
                    >
                        <vue-select
                            label="name"
                            :options="invoiceListSettings"
                            :reduce="(x) => x.key"
                            placeholder="Invoice"
                            v-model="filters.invoiceListSettingValue"
                        />
                    </md-field>

                    <md-field
                        v-if="
                            serviceData.length > 1 &&
                                showFilter([
                                    activeTabsFilters.ProcessChargesStops,
                                    activeTabsFilters.ProcessChargesShipments,
                                    activeTabsFilters.ProcessChargesTrips,
                                    activeTabsFilters.ProcessChargesOrders
                                ])
                        "
                    >
                        <vue-select
                            label="name"
                            :options="serviceData"
                            :reduce="(x) => x.serviceId"
                            placeholder="Service"
                            v-model="filters.serviceId"
                        />
                    </md-field>

                    <form-group
                        v-if="
                            showFilter([
                                activeTabsFilters.ProcessChargesStops,
                                activeTabsFilters.ProcessChargesShipments,
                                activeTabsFilters.ProcessChargesTrips,
                                activeTabsFilters.ProcessChargesOrders
                            ])
                        "
                        class="free-text"
                        label="Attempt #"
                    >
                        <md-input v-model.number="filters.attempt" />
                    </form-group>

                    <form-group
                        v-if="
                            showFilter([
                                activeTabsFilters.ProcessChargesStops,
                                activeTabsFilters.ProcessChargesShipments,
                                activeTabsFilters.ProcessChargesTrips,
                                activeTabsFilters.ProcessChargesOrders
                            ])
                        "
                        class="free-text"
                        label="Run #"
                    >
                        <md-input v-model.number="filters.runNumber" />
                    </form-group>

                    <template
                        v-if="
                            showFilter([
                                activeTabsFilters.ProcessChargesStops,
                                activeTabsFilters.ProcessChargesShipments,
                                activeTabsFilters.ProcessChargesTrips,
                                activeTabsFilters.ProcessChargesOrders
                            ])
                        "
                        v-feature="[featureNames.JobsCostApproval, featureNames.JobsChargeApproval]"
                    >
                        <md-field>
                            <process-charge-approval-status-filter
                                class="filter-steps--choices filter-approval-status"
                                :filter-approval-status-filter="filters.approvalStatus"
                                @onApprovalStatusSelected="handleApprovalStatusFilterChanged"
                            />
                        </md-field>
                    </template>

                    <md-field
                        v-if="
                            showFilter([
                                activeTabsFilters.ProcessChargesStops,
                                activeTabsFilters.ProcessChargesShipments,
                                activeTabsFilters.ProcessChargesTrips,
                                activeTabsFilters.ProcessChargesOrders
                            ])
                        "
                        class="charging-options"
                    >
                        <charging-type-options
                            label-name=""
                            @selectedOption="servicePackageChanged"
                            placeholder="Service Package"
                        ></charging-type-options>
                    </md-field>

                    <md-field
                        v-if="showFilter([activeTabsFilters.DriverAdjustments, activeTabsFilters.CustomerAdjustments])"
                    >
                        <vue-select
                            label="category"
                            :options="isTeamMember ? teamMemberAdjustmentCategories : customerAdjustmentCategories"
                            :reduce="(x) => x.invoiceAdjustmentCategoryId"
                            placeholder="Category"
                            v-model="filters.invoiceAdjustmentCategoryId"
                        />
                    </md-field>

                    <md-field
                        v-if="showFilter([activeTabsFilters.DriverAdjustments, activeTabsFilters.CustomerAdjustments])"
                    >
                        <vue-select
                            label="status"
                            :options="adjustmentStatuses"
                            :reduce="(x) => x.invoiceAdjustmentStatusId"
                            placeholder="Status"
                            v-model="filters.invoiceAdjustmentStatusId"
                        />
                    </md-field>
                </div>
            </div>
            <div v-if="
                    showFilter([
                        activeTabsFilters.ProcessChargesStops,
                        activeTabsFilters.ProcessChargesShipments,
                        activeTabsFilters.ProcessChargesOrders
                    ])
                "
                class="custom-toolbar-end">

                <div class="search--container">
                    <md-field md-clearable>
                        <md-input
                            type="text"
                            placeholder="Search"
                            v-model="filters.search"
                            @keyup.enter="handleFilter"
                        />
                    </md-field>
                    <md-tooltip 
                        v-if="showToolTip"
                    >
                        {{ getToolTip() }}
                    </md-tooltip>
                </div>
            </div>
            <div>
                <md-button
                    @click="resetFilter"
                    class="md-warning reset-button"
                >
                    Reset
                </md-button>
                <md-button
                    @click="handleFilter"
                    class="md-primary apply-button"
                >
                    Apply
                </md-button>
            </div>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins';
import { DATE_TYPES, FEATURE_NAMES } from '@/utils/constants';
import { handleRequests } from '@/helpers';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import {
    TeamRegionMemberFilterOptions,
    CustomerFilterOptions,
    ChargingTypeOptions
} from '@/components';
import moment from 'moment';
import ProcessChargeStatusFilter from './ProcessChargeStatusFilter';
import ProcessChargeApprovalStatusFilter from './ProcessChargeApprovalStatusFilter';

export default {
    name: 'ProcessChargeOverviewToolbar',
    components: {
        TeamRegionMemberFilterOptions,
        CustomerFilterOptions,
        ProcessChargeStatusFilter,
        ProcessChargeApprovalStatusFilter,

        ChargingTypeOptions
    },
    props: {
        teamRegionId: {
            type: Number,
            default: null
        },
        isCostApprovalFeatureEnabled: {
            type: Boolean,
            default: false
        },
        isChargeApprovalFeatureEnabled: {
            type: Boolean,
            default: false
        },
        servicePackages: {
            type: Array,
            default: () => []
        },
        activeTab: {
            type: String,
            default: null
        }
    },
    mixins: [GeneralMixin],
    data() {
        return {
            userId: null,
            selectedTeamRegionId: null,
            invoiceListSettings: [
                { key: 'All', name: 'All uninvoiced stops' },
                { key: 'Customer', name: 'Uninvoiced Customer' },
                { key: 'TeamMember', name: 'Uninvoiced Team member' }
            ],
            filters: {
                teamRegionId: null,
                customerId: null,
                totalCostFilter: 0,
                totalChargeFilter: 0,
                userId: null,
                status: 'All',
                fromDate: null,
                toDate: null,
                search: null,
                selectedTeamMember: null,
                invoiceListSettingValue: 'All',
                serviceId: null,
                attempt: null,
                approvalStatus: 'Unapproved',
                runNumber: null,
                rateGroupId: null,
                invoiceAdjustmentStatusId: null,
                invoiceAdjustmentCategoryId: null
            },
            serviceData: [],
            featureNames: FEATURE_NAMES,
            activeTabsFilters: {
                ProcessChargesStops: 'review-stops',
                ProcessChargesShipments: 'review-shipments',
                ProcessChargesTrips: 'review-trips',
                ProcessChargesOrders: 'review-orders',
                DriverAdjustments: 'team-member-adjustments',
                CustomerAdjustments: 'customer-adjustments'
            },
            toolTipText: null,
            adjustmentStatuses: [],
            customerAdjustmentCategories: [],
            teamMemberAdjustmentCategories: [],
            isTeamMember: true,
            showToolTip: true
        };
    },
    async mounted() {
        if (!this.allTeamMembers || this.allTeamMembers.length === 0)
            await this.$store.dispatch('team/FETCH_TEAM_MEMBERS');

        this.filters.toDate = moment().format(DATE_TYPES.internationalDate);
        const startDate = moment(this.filters.toDate);
        const tempDate = startDate.clone().subtract(14, 'days');

        this.filters.fromDate = moment(tempDate).format(DATE_TYPES.internationalDate);

        await this.getServiceList();

        if (this.invoiceAdjustmentStatuses.length === 0) {
            this.adjustmentStatuses = await this.$store.dispatch('team/FETCH_INVOICE_ADJUSTMENT_STATUSES');
        } else {
            this.adjustmentStatuses = this.invoiceAdjustmentStatuses;
        }

        if (this.invoiceAdjustmentCategories.length === 0) {
            this.adjustmentCategories = await this.$store.dispatch('team/FETCH_INVOICE_ADJUSTMENT_CATEGORIES');

            this.customerAdjustmentCategories = this.adjustmentCategories.filter((x) => x.isCustomer);
            this.teamMemberAdjustmentCategories = this.adjustmentCategories.filter((x) => x.isTeamMember);
        } else {
            this.customerAdjustmentCategories = this.invoiceAdjustmentCategories;
            this.teamMemberAdjustmentCategories = this.invoiceAdjustmentCategories;
        }

        if (this.activeTab === this.activeTabsFilters.DriverAdjustments) {
            this.isTeamMember = true;
        }

        if (this.activeTab === this.activeTabsFilters.CustomerAdjustments) {
            this.isTeamMember = false;
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            canViewTeamRegion: 'user/canViewTeamRegion',
            invoiceAdjustmentStatuses: 'team/invoiceAdjustmentStatuses',
            invoiceAdjustmentCategories: 'team/invoiceAdjustmentCategories',
            allTeamMembers: 'team/teamMembers'
        }),
        statusFilterOptions() {
            if (this.activeTab === this.activeTabsFilters.ProcessChargesOrders) {
                return ['All', 'Completed', 'Delivery Failed'];
            }
            return ['All', 'Complete', 'Failed'];
        }
    },
    watch: {
        activeTab(newValue, oldValue) {
            if (this.activeTab === this.activeTabsFilters.DriverAdjustments) {
                this.isTeamMember = true;
            }

            if (this.activeTab === this.activeTabsFilters.CustomerAdjustments) {
                this.isTeamMember = false;
            }

            if (
                this.activeTab === this.activeTabsFilters.ProcessChargesStops ||
                this.activeTab === this.activeTabsFilters.ProcessChargesShipments ||
                this.activeTab === this.activeTabsFilters.ProcessChargesOrders
            ) {
                this.showToolTip = true;
            } else {
                this.showToolTip = false;
            }
        }
    },
    methods: {
        // eslint-disable-next-line func-names
        handleFilter: _.debounce(function() {
            this.handleFilteredValue();
        }, 700),
        handleFilteredValue() {
            this.emitEvent('onFilterProcessCharges');
        },
        handleTeamRegionMemberChanged(val) {
            this.userId = val.teamMember?.userId;
            this.selectedTeamRegionId = val.teamRegionId;
        },
        handleKeyword(data) {
            this.filters.search = data.searchText;
        },
        handleCustomerChanged(value) {
            this.filters.customerId = value;
        },
        handleStatusFilterChanged(value) {
            this.filters.status = String(value);
        },
        handleApprovalStatusFilterChanged(value) {
            this.filters.approvalStatus = String(value);
        },

        emitEvent(evt) {
            this.$nextTick(() => {
                if (this.filters.fromDate) {
                    this.filters.fromDate = this.$options.filters.dateFormat(
                        this.filters.fromDate,
                        this.DATE_TYPES.internationalDate
                    );
                }

                if (this.filters.toDate) {
                    this.filters.toDate = this.$options.filters.dateFormat(
                        this.filters.toDate,
                        this.DATE_TYPES.internationalDate
                    );
                }

                this.filters.userId = this.userId;
                this.filters.teamRegionId = this.selectedTeamRegionId;

                this.$emit(evt, {
                    ...this.filters
                });
            });
        },
        async getServiceList() {
            const endpoint = `/api/services/list`;
            const result = await handleRequests(endpoint);
            this.serviceData = result.data;

            const allElementItem = {
                serviceId: 0,
                name: 'All'
            };

            this.serviceData.unshift(allElementItem);
        },
        servicePackageChanged(servicePackage) {
            if (servicePackage !== undefined) {
                this.filters.rateGroupId = servicePackage?.rateGroupId ?? null;
            }
        },
        showFilter(filter) {
            if (filter === null || filter === undefined || filter.length === 0) {
                return true;
            }

            return filter.includes(this.activeTab);
        },
        resetFilter() {
            if (this.filters && typeof this.filters === 'object') {
                Object.keys(this.filters).forEach((key) => {
                    this.filters[key] = null;
                });
            }

            this.filters.status = 'All';
            this.filters.invoiceListSettingValue = 'All';
            this.filters.approvalStatus = 'Unapproved';

            this.filters.toDate = moment().format(DATE_TYPES.internationalDate);
            const startDate = moment(this.filters.toDate);
            const tempDate = startDate.clone().subtract(14, 'days');
            this.filters.fromDate = moment(tempDate).format(DATE_TYPES.internationalDate);
        },
        getToolTip() {
            if (
                this.activeTab === this.activeTabsFilters.ProcessChargesStops ||
                this.activeTab === this.activeTabsFilters.ProcessChargesShipments
            ) {
                return 'Searches: Ref / Source Ref and Customer name.';
            }

            if (this.activeTab === this.activeTabsFilters.ProcessChargesOrders) {
                return 'Searches: Order number, Source Ref and PO Number.';
            }

            return null;
        }
    }
};
</script>

<style lang="scss" scoped>
.custom-toolbar {
    align-items: start;
    margin-top: 1px;
    .custom-toolbar-start {
        flex: 3;
    }
}

.apply-button {
    position: absolute;
    bottom: 0;
    right: 25px;
    padding: 10px;
}

.reset-button {
    position: absolute;
    bottom: 0;
    right: 150px;
    padding: 10px;
}

::v-deep .md-toolbar {
    .md-field {
        &:first-child,
        &:last-child {
            margin: 8px;
        }
    }

    .stops-search {
        padding-bottom: 10px;
        &::before,
        &::after {
            bottom: 10px;
        }
    }
}

::v-deep .filter-steps--container {
    .filter-steps--choices {
        margin-top: 0;
        padding-bottom: 0;
        > .md-input {
            display: initial;
        }
    }
}

.filter-steps--container {
    ::v-deep .md-field {
        display: inline-block;
        width: 200px;
        min-height: 48px;
        margin-right: 20px;
        margin-top: 0;
        vertical-align: top;
    }
    .filter-step-date {
        min-width: 250px;
        margin-right: 0;
        min-height: initial;
        position: absolute;
        z-index: 1;
    }

    .filter-status,
    .filter-approval-status {
        min-width: 150px;
        margin-right: 0;
        min-height: initial;
        position: absolute;
    }

    .filter-button--container {
        display: inline-block;
    }
    ::v-deep .md-datepicker:after,
    ::v-deep .md-datepicker:before {
        bottom: 0;
        height: 0;
    }

    ::v-deep .md-datepicker:before,
    ::v-deep .md-datepicker:after {
        bottom: 30px;
        color: #aaaaaa;
        font-weight: 400;
        font-size: 14px;
        transform: none;
        z-index: 1;
    }

    .start-date:before,
    .start-date:after {
        content: 'Start Date';
    }
    .end-date:before,
    .end-date:after {
        content: 'End Date';
    }

    ::v-deep .md-has-value:not(.free-text):before,
    ::v-deep .md-has-value:not(.free-text):after {
        bottom: 0;
        height: 0;
        content: '';
    }

    ::v-deep .md-datepicker .md-input {
        position: absolute;
        z-index: 9;
        width: 150px;
    }

    ::v-deep .md-datepicker .md-input-action {
        z-index: 99;
        right: 52px;
    }
}
::v-deep .vs__search::placeholder {
    color: #aaaaaa;
    font-size: 14px;
}
::v-deep .vs--searchable .vs__dropdown-toggle {
    border: none;
    padding-bottom: 5px;
    margin-top: 4px;
    background-color: transparent;
    cursor: pointer;
}
::v-deep .vs--disabled .vs__clear,
::v-deep .vs--disabled .vs__dropdown-toggle,
::v-deep .vs--disabled .vs__open-indicator,
::v-deep .vs--disabled .vs__search,
::v-deep .vs--disabled .vs__selected {
    background-color: transparent;
}

::v-deep .vs__search {
    cursor: pointer;
}

.datepicker-noevent {
    ::v-deep .md-datepicker {
        input {
            pointer-events: none;
        }
    }
}

.status-filter {
    width: 150px !important;
}

.filter-steps--container {
    .filter-steps--choices {
        margin-top: 0;
        padding-bottom: 0;
        > .md-input {
            display: initial;
        }
    }
}

.charging-options {
    height: 0px;
}

.search--container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    ::v-deep .md-field {
        box-sizing: border-box;
        margin-top: 0;
        &::before,
        &::after {
            bottom: 10px;
        }
    }
    .search-button--container {
        margin-right: 12px;
        margin-left: 4px;
        display: inline-block;
    }
}
</style>
